import { httpRequestGenerator } from '../services/utilities';
import { baseUrl, enableOnPremise, routerApp } from '../app.module';

routerApp.factory('PortService', ['$http', function($http) {

    const requestFunc = httpRequestGenerator(enableOnPremise, $http);

    return {
        saveCustomPort (port) {
            const requestFunc = httpRequestGenerator(enableOnPremise, $http);
            const url = `${baseUrl}management/ports_main/create`

            console.log('port service', port)

            return requestFunc({url,
                method: 'POST',
                data: port
            })
        },

        getPorts: function() {
            const requestFunc = httpRequestGenerator(enableOnPremise, $http);
            const url = `${baseUrl}v1/ports/detailed`;

            return requestFunc({
                url, 
                method: 'GET',
            })
        },

        getPortCallPurposes: function(){
            const url = baseUrl + 'referenceData';
            return requestFunc({
                url,
                method: 'GET'
            })
        }
    }
}]);